import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submenu", "chevron"]

  connect() {
    // Initialize with submenu collapsed
    this.submenuTarget.style.maxHeight = "0"
    this.submenuTarget.classList.add("overflow-hidden", "transition-all", "duration-300", "ease-in-out")
  }

  toggle() {
    // Toggle submenu visibility using max-height
    if (this.submenuTarget.style.maxHeight === "0px") {
      this.submenuTarget.style.maxHeight = `${this.submenuTarget.scrollHeight}px`
    } else {
      this.submenuTarget.style.maxHeight = "0"
    }
    
    // Rotate chevron when menu is open
    this.chevronTarget.classList.toggle("rotate-90")
    
    // Add transition class for smooth rotation
    this.chevronTarget.classList.add("transform", "transition-transform", "duration-200")
  }
} 